import { render } from "./GutenbergHighlight.vue?vue&type=template&id=530ff4dc"
import script from "./GutenbergHighlight.vue?vue&type=script&lang=js"
export * from "./GutenbergHighlight.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__